<div class="ds-grid ds-grid--3">
	<!-- Success Toasters -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Success Toasters</h3>
			<p class="ds-example__header-subtitle">Success notifications with optional descriptions</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Simple Success'"
					[color]="'success'"
					[size]="'small'"
					(action)="showSuccess()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'With Description'"
					[color]="'success'"
					[size]="'small'"
					(action)="showSuccessWithDescription()">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Info Toasters -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Info Toasters</h3>
			<p class="ds-example__header-subtitle">Informational messages with titles</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Simple Info'"
					[color]="'info'"
					[size]="'small'"
					(action)="showInfo()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'With Title and Actions'"
					[color]="'info'"
					[size]="'small'"
					(action)="showInfoWithTitleAndActions()">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Warning Toasters -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Warning Toasters</h3>
			<p class="ds-example__header-subtitle">Warning messages with optional actions</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Simple Warning'"
					[color]="'warning'"
					[size]="'small'"
					(action)="showWarning()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'With Actions'"
					[color]="'warning'"
					[size]="'small'"
					(action)="showWarningWithActions()">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Error Toasters -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Error Toasters</h3>
			<p class="ds-example__header-subtitle">Error notifications with descriptions and actions</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Simple Error'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showError()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'With Description'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showErrorWithDescription()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'With Actions'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showErrorWithActions()">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Error Toasters with Errors -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Error Toasters with Error Details</h3>
			<p class="ds-example__header-subtitle">Error notifications with detailed error information</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Single Error'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showErrorWithSingleError()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Multiple Errors'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showErrorWithMultipleErrors()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'With Details'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showErrorWithDetails()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'With Values'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showErrorWithValues()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Complex Error'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showErrorComplex()">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<!-- Advanced Features -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Advanced Features</h3>
			<p class="ds-example__header-subtitle">Manual close, custom duration, and multiple toasters</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Manual Close'"
					[color]="'info'"
					[size]="'small'"
					(action)="showManualClose()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Custom Duration'"
					[color]="'info'"
					[size]="'small'"
					(action)="showCustomDuration()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Multiple Toasters'"
					[color]="'primary'"
					[size]="'small'"
					(action)="showMultipleToasters()">
				</eif-custom-button>
			</div>
		</div>
	</div>
</div>
